import React from 'react';

import { ScreenContainerSafeAreaProvider } from '@components/ScreenContainer';
import { RuntimeConfig } from '@helpers/RuntimeConfig';
import OnboardedTab, { OnboardedTabParamList } from '@navigation/OnboardedTab';
import { OnboardedStackRoute } from '@navigation/Routes';
import type { CreatePlanScreenProps } from '@navigation/Types';
import { NavigatorScreenParams } from '@react-navigation/native';
import { StackNavigationOptions, createStackNavigator } from '@react-navigation/stack';
import CreatePlanScreen from '@screens/Plan/Form';

export type OnboardedStackParamList = {
  [OnboardedStackRoute.OnboardedTab]: NavigatorScreenParams<OnboardedTabParamList>;
  [OnboardedStackRoute.CreatePlan]: undefined;
};

const OnboardedStackNavigator = createStackNavigator<OnboardedStackParamList>();

const createPlanScreenOptions = {
  animation: RuntimeConfig.isE2E ? 'none' : 'default',
  presentation: RuntimeConfig.isE2E ? 'card' : 'modal',
  headerShown: true,
  headerTitle: 'Add a Plan',
  headerBackTitle: 'Close',
} satisfies StackNavigationOptions;

export default function OnboardedStack() {
  return (
    <OnboardedStackNavigator.Navigator
      id={undefined}
      initialRouteName={OnboardedStackRoute.OnboardedTab}
      screenOptions={{
        headerShown: false,
      }}>
      <OnboardedStackNavigator.Screen
        name={OnboardedStackRoute.OnboardedTab}
        component={OnboardedTab}
      />
      <OnboardedStackNavigator.Screen
        name={OnboardedStackRoute.CreatePlan}
        component={CreatePlanModalScreen}
        options={createPlanScreenOptions}
      />
    </OnboardedStackNavigator.Navigator>
  );
}

function CreatePlanModalScreen(props: CreatePlanScreenProps) {
  return (
    <ScreenContainerSafeAreaProvider safeAreaEdges={['bottom']}>
      <CreatePlanScreen {...props} />
    </ScreenContainerSafeAreaProvider>
  );
}
